
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { lambda_type, unit_type, class_type, record_type, list_type, option_type, float64_type, string_type, union_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { FormState__startLoading, FormState__setValidationResponse_5219762A, ToolId__get_unwrap, FormState_get_empty, RequestedValue$1, TokenDataDto_$reflection, FormState_$reflection, RequestedValue$1_$reflection, ClientApiResponse$1_$reflection } from "../../Shared/Shared.js";
import { DataTransfer_DetailSet_$reflection } from "../../Shared/Set.js";
import { Helper_toolId, ToolTypes_$reflection } from "../../Shared/Tool.js";
import { MultiPlannedReturnDateUpdateDto, MultiPlannedReturnDateUpdateDto_$reflection } from "../../Shared/MultiOperation.js";
import { exists, length, tryHead, toArray as toArray_1, tryPick, contains, choose, append as append_1, collect, singleton as singleton_1, filter, cons, find, ofArray, map, empty, isEmpty } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Cmd_none, Cmd_ofEffect, Cmd_batch } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { iterate, toArray, empty as empty_1, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { getSelectedSets } from "../../Requests/Set.js";
import { Cmd_getSelectedTools } from "../../Requests/Tool.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { newGuid } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { createObj, equals, stringHash } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { unwrap, toArray as toArray_2, map as map_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { toISOString } from "../../Common.js";
import { Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../CommunicationV2.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { join, concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { FSharpMap__get_IsEmpty, toList as toList_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { ColumnDefinition$1, CellContent } from "../Table/Types.js";
import { InvalidTextValue } from "../../Components/Text.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { InfiniteTable } from "../Table/InfiniteTable.js";
import Recycle_Bin_1 from "../../../public/assets/icons/Recycle_Bin_1.svg";
import { TableControlElement$1, TableControl$1 } from "../Table/Table.js";
import { TabsMenu } from "../TabsMenu.js";
import { InformationAlert } from "../../Components/Alert.js";
import { DatePicker } from "../../Components/DatePicker.js";
import { Button } from "../../Components/Button.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { ModalSheet } from "../../Components/ModalSheet.js";
import { Skeleton } from "../../Components/Skeleton.js";

export class TableElementType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Tool", "Set"];
    }
}

export function TableElementType_$reflection() {
    return union_type("Widgets.Modals.MultiPlannedReturnDateModal.TableElementType", [], TableElementType, () => [[], []]);
}

export class TableElement extends Record {
    constructor(Id, ElementId, AssignedReceiverName, Manufacturer, Model, Name, AdditionalName, InventoryNumber, Quanity, Type, Unit, Commission, SelectedStorageId, AvailableStorageIds) {
        super();
        this.Id = Id;
        this.ElementId = ElementId;
        this.AssignedReceiverName = AssignedReceiverName;
        this.Manufacturer = Manufacturer;
        this.Model = Model;
        this.Name = Name;
        this.AdditionalName = AdditionalName;
        this.InventoryNumber = InventoryNumber;
        this.Quanity = Quanity;
        this.Type = Type;
        this.Unit = Unit;
        this.Commission = Commission;
        this.SelectedStorageId = SelectedStorageId;
        this.AvailableStorageIds = AvailableStorageIds;
    }
}

export function TableElement_$reflection() {
    return record_type("Widgets.Modals.MultiPlannedReturnDateModal.TableElement", [], TableElement, () => [["Id", string_type], ["ElementId", string_type], ["AssignedReceiverName", string_type], ["Manufacturer", string_type], ["Model", string_type], ["Name", string_type], ["AdditionalName", string_type], ["InventoryNumber", string_type], ["Quanity", option_type(float64_type)], ["Type", TableElementType_$reflection()], ["Unit", string_type], ["Commission", string_type], ["SelectedStorageId", option_type(string_type)], ["AvailableStorageIds", list_type(string_type)]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["OnSave", "SetPlannedReturnDate", "AddElement", "RemoveElement", "InitTableElements", "PlannedReturnDateUpdateResponse", "SetsFetched", "ToolsFetched", "FetchError"];
    }
}

function Msg_$reflection() {
    return union_type("Widgets.Modals.MultiPlannedReturnDateModal.Msg", [], Msg, () => [[], [["Item", option_type(class_type("System.DateTime"))]], [["id", string_type]], [["id", string_type]], [], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", list_type(DataTransfer_DetailSet_$reflection())]], [["Item", list_type(ToolTypes_$reflection())]], [["Item", class_type("System.Exception")]]]);
}

class State extends Record {
    constructor(SuccessCallback, OnClose, Sets, Tools, TableElements, RemovedElements, Dto, PlannedReturnDate, FormState, UserData) {
        super();
        this.SuccessCallback = SuccessCallback;
        this.OnClose = OnClose;
        this.Sets = Sets;
        this.Tools = Tools;
        this.TableElements = TableElements;
        this.RemovedElements = RemovedElements;
        this.Dto = Dto;
        this.PlannedReturnDate = PlannedReturnDate;
        this.FormState = FormState;
        this.UserData = UserData;
    }
}

function State_$reflection() {
    return record_type("Widgets.Modals.MultiPlannedReturnDateModal.State", [], State, () => [["SuccessCallback", lambda_type(unit_type, unit_type)], ["OnClose", lambda_type(unit_type, unit_type)], ["Sets", RequestedValue$1_$reflection(list_type(DataTransfer_DetailSet_$reflection()))], ["Tools", RequestedValue$1_$reflection(list_type(ToolTypes_$reflection()))], ["TableElements", list_type(TableElement_$reflection())], ["RemovedElements", list_type(TableElement_$reflection())], ["Dto", MultiPlannedReturnDateUpdateDto_$reflection()], ["PlannedReturnDate", option_type(class_type("System.DateTime"))], ["FormState", FormState_$reflection()], ["UserData", TokenDataDto_$reflection()]]);
}

function init(successCallback, onClose, userData, plannedReturnDateProps) {
    return [new State(successCallback, onClose, isEmpty(plannedReturnDateProps.SetIds) ? (new RequestedValue$1(1, [empty()])) : (new RequestedValue$1(0, [])), isEmpty(plannedReturnDateProps.ToolIds) ? (new RequestedValue$1(1, [empty()])) : (new RequestedValue$1(0, [])), empty(), empty(), new MultiPlannedReturnDateUpdateDto(undefined, "", empty(), empty()), undefined, FormState_get_empty(), userData), Cmd_batch(toList(delay(() => append(!isEmpty(plannedReturnDateProps.SetIds) ? singleton(getSelectedSets(plannedReturnDateProps.SetIds, (Item) => (new Msg(6, [Item])), (Item_1) => (new Msg(8, [Item_1])))) : empty_1(), delay(() => (!isEmpty(plannedReturnDateProps.ToolIds) ? singleton(Cmd_getSelectedTools(map(ToolId__get_unwrap, plannedReturnDateProps.ToolIds), (Item_2) => (new Msg(7, [Item_2])), (Item_3) => (new Msg(8, [Item_3])))) : empty_1()))))))];
}

function update(msg, state) {
    switch (msg.tag) {
        case 5: {
            const response_2 = msg.fields[0];
            if (response_2.tag === 1) {
                return [new State(state.SuccessCallback, state.OnClose, state.Sets, state.Tools, state.TableElements, state.RemovedElements, state.Dto, state.PlannedReturnDate, FormState__setValidationResponse_5219762A(state.FormState, response_2.fields[0]), state.UserData), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.SuccessCallback, state.OnClose, state.Sets, state.Tools, state.TableElements, state.RemovedElements, state.Dto, state.PlannedReturnDate, FormState_get_empty(), state.UserData), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                    state.SuccessCallback();
                }), Cmd_successToast("general.saved_successfully"), Cmd_ofEffect((_arg_1) => {
                    state.OnClose();
                })]))];
            }
        }
        case 1:
            return [new State(state.SuccessCallback, state.OnClose, state.Sets, state.Tools, state.TableElements, state.RemovedElements, state.Dto, msg.fields[0], state.FormState, state.UserData), Cmd_none()];
        case 2: {
            const id = msg.fields[0];
            return [new State(state.SuccessCallback, state.OnClose, state.Sets, state.Tools, cons(find((tableElement) => (tableElement.Id === id), state.RemovedElements), state.TableElements), filter((tableElement_1) => (tableElement_1.Id !== id), state.RemovedElements), state.Dto, state.PlannedReturnDate, state.FormState, state.UserData), Cmd_none()];
        }
        case 3: {
            const id_1 = msg.fields[0];
            const selectedElement_1 = find((tableElement_2) => (tableElement_2.Id === id_1), state.TableElements);
            return [new State(state.SuccessCallback, state.OnClose, state.Sets, state.Tools, filter((tableElement_3) => (tableElement_3.Id !== id_1), state.TableElements), cons(selectedElement_1, state.RemovedElements), state.Dto, state.PlannedReturnDate, state.FormState, state.UserData), Cmd_none()];
        }
        case 6:
            return [new State(state.SuccessCallback, state.OnClose, new RequestedValue$1(1, [msg.fields[0]]), state.Tools, state.TableElements, state.RemovedElements, state.Dto, state.PlannedReturnDate, state.FormState, state.UserData), singleton_1((dispatch) => {
                dispatch(new Msg(4, []));
            })];
        case 7:
            return [new State(state.SuccessCallback, state.OnClose, state.Sets, new RequestedValue$1(1, [msg.fields[0]]), state.TableElements, state.RemovedElements, state.Dto, state.PlannedReturnDate, state.FormState, state.UserData), singleton_1((dispatch_1) => {
                dispatch_1(new Msg(4, []));
            })];
        case 4: {
            const matchValue = state.Tools;
            const matchValue_1 = state.Sets;
            let matchResult, sets, tools;
            if (matchValue.tag === 0) {
                matchResult = 1;
            }
            else if (matchValue_1.tag === 0) {
                matchResult = 1;
            }
            else {
                matchResult = 0;
                sets = matchValue_1.fields[0];
                tools = matchValue.fields[0];
            }
            switch (matchResult) {
                case 0: {
                    const setToolIds = map((tool) => tool.ToolId, collect((set$) => set$.AssignedTools, sets));
                    return [new State(state.SuccessCallback, state.OnClose, state.Sets, state.Tools, append_1(map((set$_1) => (new TableElement(newGuid(), set$_1.Id, "", set$_1.MasterData.Manufacturer, set$_1.MasterData.Model, set$_1.MasterData.Name, "", set$_1.MasterData.InventoryNumber, undefined, new TableElementType(1, []), "piece", "", undefined, empty())), sets), choose((tool_2) => {
                        if (tool_2.tag === 1) {
                            return undefined;
                        }
                        else {
                            const tool_3 = tool_2.fields[0];
                            return new TableElement(newGuid(), ToolId__get_unwrap(tool_3.Id), "", tool_3.Manufacturer, tool_3.Model, tool_3.DisplayName, "", tool_3.InventoryNumber, undefined, new TableElementType(0, []), "piece", "", undefined, empty());
                        }
                    }, filter((tool_1) => !contains(ToolId__get_unwrap(Helper_toolId(tool_1)), setToolIds, {
                        Equals: (x_1, y) => (x_1 === y),
                        GetHashCode: (x_1) => (stringHash(x_1) | 0),
                    }), tools))), state.RemovedElements, state.Dto, state.PlannedReturnDate, state.FormState, state.UserData), Cmd_none()];
                }
                default:
                    return [state, Cmd_none()];
            }
        }
        case 8:
            return [new State(state.SuccessCallback, state.OnClose, state.Sets, state.Tools, state.TableElements, state.RemovedElements, state.Dto, state.PlannedReturnDate, FormState_get_empty(), state.UserData), Cmd_errorToast("general.a_error_occured")];
        default: {
            let updatedDto;
            const ReturnDate = map_1(toISOString, state.PlannedReturnDate);
            const ToolIds = map((element_1) => element_1.ElementId, filter((element) => equals(element.Type, new TableElementType(0, [])), state.TableElements));
            updatedDto = (new MultiPlannedReturnDateUpdateDto(ReturnDate, state.Dto.ReceiverId, map((element_3) => element_3.ElementId, filter((element_2) => equals(element_2.Type, new TableElementType(1, [])), state.TableElements)), ToolIds));
            return [new State(state.SuccessCallback, state.OnClose, state.Sets, state.Tools, state.TableElements, state.RemovedElements, state.Dto, state.PlannedReturnDate, FormState__startLoading(state.FormState), state.UserData), Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let url_2;
                return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
                    const pr = response.arrayBuffer();
                    return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
                }, refreshOn)))(true);
            })), ["/api/multi-operations/planned-return-date", toString(0, Auto_generateBoxedEncoder_437914C6(MultiPlannedReturnDateUpdateDto_$reflection(), undefined, undefined, undefined)(updatedDto))], (Item) => (new Msg(5, [Item])), (Item_1) => (new Msg(8, [Item_1])))];
        }
    }
}

function elementValidation(translate, formState, elementId) {
    return tryPick((tupledArg) => {
        if (tupledArg[0].startsWith(concat(elementId, ..."-"))) {
            return translate(tupledArg[1]);
        }
        else {
            return undefined;
        }
    }, toList_1(formState.Validations));
}

function Table(props) {
    let elems_2;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const columnDefinition = toArray(delay(() => append(!FSharpMap__get_IsEmpty(props.FormState.Validations) ? singleton(new ColumnDefinition$1("hint", "", t("assign_multiple_tools_dialog.hint"), (row) => {
        const matchValue = elementValidation(t, props.FormState, row.ElementId);
        if (matchValue == null) {
            return new CellContent(0, [""]);
        }
        else {
            const value = matchValue;
            return new CellContent(2, [createElement(InvalidTextValue, {
                TestId: concat(row.Id, ..."-validation-message"),
                Text: value,
            })]);
        }
    }, "none", "text")) : empty_1(), delay(() => append(singleton(new ColumnDefinition$1("manufacturer", "", t("assign_multiple_tools_dialog.manufacturer"), (row_1) => (new CellContent(0, [row_1.Manufacturer])), "none", "text")), delay(() => append(singleton(new ColumnDefinition$1("model", "", t("assign_multiple_tools_dialog.model"), (row_2) => (new CellContent(0, [row_2.Model])), "none", "text")), delay(() => append(singleton(new ColumnDefinition$1("name", "", t("tool.displayname"), (row_3) => (new CellContent(0, [row_3.Name])), "none", "text")), delay(() => singleton(new ColumnDefinition$1("inventoryNumber", "", t("assign_multiple_tools_dialog.inventory_number"), (row_4) => (new CellContent(0, [row_4.InventoryNumber])), "none", "text"))))))))))));
    const elementTable = (tableKey, rows, onSelected) => {
        let elems, TableRows, Options;
        return reactElement("div", createObj(ofArray([["className", join(" ", ["flex-1", "basis-[36rem]", "min-h-[36rem]", "overflow-hidden"])], (elems = [createElement(InfiniteTable, (TableRows = toArray_1(rows), (Options = {
            BorderStyle: "row",
            CSVDownload: false,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: ["manufacturer", "asc"],
            Fullscreen: false,
            GlobalSearch: false,
            RowSelection: "singleRow",
            SaveTableConfiguration: false,
            WithQueryParameters: false,
        }, {
            ColumnDefinitions: columnDefinition,
            Controls: singleton_1(new TableControlElement$1(0, [new TableControl$1(t("general.remove"), Recycle_Bin_1(), props.FormState.IsLoading ? undefined : ((rows_1) => {
                iterate((row_5) => {
                    props.Dispatch(onSelected(row_5.Id));
                }, toArray_2(tryHead(rows_1)));
            }), true, false, "tools-dialog-toolreservation-dialog-remove-button")])),
            Options: Options,
            TableKey: tableKey,
            TableRows: TableRows,
        })))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
    };
    return reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4", "flex", "flex-col", "flex-1"])], (elems_2 = toList(delay(() => {
        let elems_1, arg_1;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "gap-4", "mb-4"])], (elems_1 = [createElement(TabsMenu, {
            Tabs: ofArray([{
                IsSelected: props.IsAddedElementTabVisible,
                Label: t("assign_multiple_tools_dialog.tools"),
                OnClick: () => {
                    props.SetIsAddedElementTabVisible(true);
                },
                TestId: "multi-modal-tab-elements",
            }, {
                IsSelected: !props.IsAddedElementTabVisible,
                Label: (arg_1 = {
                    numberOfRemovedTools: length(props.RemovedElements),
                }, patternInput[1].t("assign_multiple_tools_dialog.removed_elements", arg_1)),
                OnClick: () => {
                    props.SetIsAddedElementTabVisible(false);
                },
                TestId: "multi-modal-tab-removed-elements",
            }]),
        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => (props.IsAddedElementTabVisible ? singleton(elementTable("multi-planned-return-date-elements", props.TableElements, (id) => (new Msg(3, [id])))) : singleton(elementTable("multi-planned-return-date-removed-elements", props.RemovedElements, (id_1) => (new Msg(2, [id_1])))))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function Form(props) {
    let elems_1, elems, Label_1;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-4", "mt-4", "w-96"])], (elems_1 = [createElement(InformationAlert, {
        Label: t("multi_operation.planned_return_date.information"),
    }), createElement(DatePicker, {
        ComponentState: props.FormState,
        IsClearable: true,
        Label: t("tool.dialog_planned_return_date"),
        OnChange: (value_1) => {
            props.Dispatch(new Msg(1, [value_1]));
        },
        TestId: "change-return-date-test-id",
        Value: unwrap(props.PlannedReturnDate),
    }), reactElement("div", createObj(singleton_1((elems = [createElement(Button, (Label_1 = t("general.save"), {
        ComponentState: (props.FormState === "disabled") ? "disabled" : "enabled",
        Label: Label_1,
        OnClick: () => {
            props.Dispatch(new Msg(0, []));
        },
        TestId: "multi-operation-modal-planned-return-date-save-button",
        Variant: "primary",
    }))], ["children", reactApi.Children.toArray(Array.from(elems))]))))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function Content(props) {
    let elems_2, elems_1;
    const patternInput = useTranslation();
    const patternInput_1 = reactApi.useState(true);
    const isAddedElementsTabSelected = patternInput_1[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full", "flex", "flex-col"])], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["p-4", "flex", "flex-col", "flex-1"])], (elems_1 = toList(delay(() => {
        let elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "flex-1"])], (elems = [createElement(Table, {
            Dispatch: props.Dispatch,
            FormState: props.FormState,
            IsAddedElementTabVisible: isAddedElementsTabSelected,
            RemovedElements: props.RemovedElements,
            SetIsAddedElementTabVisible: patternInput_1[1],
            TableElements: props.TableElements,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let IsTableElementsEmpty;
            return isAddedElementsTabSelected ? singleton(createElement(Form, (IsTableElementsEmpty = isEmpty(props.TableElements), {
                Dispatch: props.Dispatch,
                Dto: props.Dto,
                FormState: componentState,
                HasTableElementEmptyStorageId: exists((tableElement) => (tableElement.SelectedStorageId == null), props.TableElements),
                IsTableElementsEmpty: IsTableElementsEmpty,
                PlannedReturnDate: unwrap(props.PlannedReturnDate),
            }))) : empty_1();
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function MultiUpdatePlannedReturnDateModalSheet(props) {
    let elems;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.SuccessCallback, props.OnClose, props.UserData, props.PlannedReturnDateProps), update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_1 = patternInput[0];
    const patternInput_1 = useTranslation();
    return reactElement("div", createObj(singleton_1((elems = [createElement(ModalSheet, {
        CloseButtonTestId: "",
        Content: (state_1.Sets.tag === 0) ? createElement(Skeleton, {
            Variant: "table",
        }) : ((state_1.Tools.tag === 0) ? createElement(Skeleton, {
            Variant: "table",
        }) : createElement(Content, {
            Dispatch: patternInput[1],
            Dto: state_1.Dto,
            FormState: state_1.FormState,
            PlannedReturnDate: unwrap(state_1.PlannedReturnDate),
            RemovedElements: state_1.RemovedElements,
            TableElements: state_1.TableElements,
        })),
        Controls: empty(),
        IsModalOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: patternInput_1[0]("tool.planned_return_date"),
    })], ["children", reactApi.Children.toArray(Array.from(elems))]))));
}

